import { render, staticRenderFns } from "./zhenshi.vue?vue&type=template&id=6b3f3a04&scoped=true&"
import script from "./zhenshi.vue?vue&type=script&lang=js&"
export * from "./zhenshi.vue?vue&type=script&lang=js&"
import style0 from "./zhenshi.vue?vue&type=style&index=0&id=6b3f3a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f3a04",
  null
  
)

export default component.exports